(function (Header, $, undefined) {

	var bindUIActions = function () {

		/*----------  Open/Close mega menu  ----------*/
		$('.fixed-header-wrap').on('keydown', '.skagen-dropdown-toggle', function(evt) {
			var selectedElement = $(evt.currentTarget);

			/* Check for the down arrow key */
			if(evt.which === 40) {
				selectedElement.prop('aria-expanded', 'true');
				selectedElement.parent().addClass('open');
				return false;
			} else if(evt.which === 38) {
				selectedElement.prop('aria-expanded', 'false');
				selectedElement.parent().removeClass('open');
			}
		});

		/*----------  Exit mega menu  ----------*/
		$('.shifter-page').on('focusin', function() {
			/* Get open dropdown on the page */
			var openDropdown = $('.skagen-dropdown.open');

			/* If new focused element isn't in open dropdown, close it */
			if(openDropdown.length !== 0 && openDropdown.has(document.activeElement).length === 0) {
				openDropdown.removeClass('open');
				openDropdown.find('.skagen-dropdown-toggle').prop('aria-expanded', 'false');
			}
		});

	 	/*---------- Calculate height of header to push page down ----------*/
      	var headerHeight = $('.fixed-header-wrap').height();
      	$('.page-wrap').css({'padding-top' : headerHeight});
      	
	};

	Header.init = function () {
		bindUIActions();
	};

}(window.Header = window.Header || {}, jQuery));
